exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test {\n  width: '400px';\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ColeMarsteller/Desktop/agoogle/src/app/canvas/canvas.component.css
// module id = ../../../../../src/app/canvas/canvas.component.css
// module chunks = main